import axios from 'axios'
import AxiosUtils from '@/utils/axios.js'

AxiosUtils.addDefaultInterceptorsTo(axios)
